<template>
  <App>
    <Header imageLogo :userInfo="user" :helpMenu="helpMenu"/>
    <Main :appVersion="version"/>
  </App>
</template>

<script>
import { App, Header, Main } from '@locaweb/design-system-vue'
import { authStore } from '@/store/auth'
import { addToDataLayer } from '@/config/dataLayerService'

const version = require('../../../package.json').version

export default {
  name: 'TheMainLayout',
  props: {
    HelpMenu: Object
  },
  components: {
    Header,
    Main,
    App
  },
  mounted () {
    addToDataLayer({
      event: 'userId',
      userId: this.user.additionalInfo
    })
  },
  data () {
    return {
      helpMenu: [
        {
          title: 'FAQ Wordpress',
          link: '/f/questions'
        }
      ]
    }
  },
  setup () {
    return { version }
  },
  computed: {
    user () {
      return authStore().userInfo
    }
  }
}
</script>
